import { cn } from "./cn";

export interface SkeletonProps {
  className?: string;
}

/** Single shimmer block. Compose to mimic the shape of loading content. */
export function Skeleton({ className }: SkeletonProps) {
  return (
    <div
      className={cn("bg-slate-200/80 rounded animate-pulse", className)}
      aria-hidden="true"
    />
  );
}

export interface SkeletonTextProps {
  lines?: number;
  className?: string;
}

/** A stack of shimmer lines with a shorter final line. */
export function SkeletonText({ lines = 3, className }: SkeletonTextProps) {
  return (
    <div className={cn("space-y-2", className)} aria-hidden="true">
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton
          key={i}
          className={cn("h-3", i === lines - 1 ? "w-2/3" : "w-full")}
        />
      ))}
    </div>
  );
}
